$(document).ready(function() {
    $('body').append(`
      <div class="lightbox">
        <a href="#lightbox" class="lightbox-close lightbox-toggle">X</a>
        <div class="lightbox-container">
          <div class="row">
            <div class="col-sm-12 lightbox-column">
              
            </div>
          </div>
        </div>
      </div>
    `);
  
  $('.lightbox-toggle').on('click', (event) => {
    event.preventDefault();
    $('.lightbox').fadeToggle('fast');
    
    let context = $(event.currentTarget).attr('data-lightbox-type');
    let content = $(event.currentTarget).attr('data-lightbox-content');
 
    $('.lightbox-column').append(`
        <img src="${content}" class="img-" frameborder="0" allowfullscreen>
    `);
  });
  
  $('.lightbox-close').on('click', (event) => {
    event.preventDefault();
    $('.lightbox-column > *').remove();
  });

  $(window).on('resize', function() {
    if ($(window).width() <= 1023) {
       $('#product-lookbook').turn("disable", true);
    }
  });

    $('#carousel-featured').owlCarousel({
      items: 1,
      nav: false,
      dots: false,
      loop: true,
      autoplay: false
    });

     let isCarouselInitialized = false;

  
  function initMobileCarousel() {
    if (!isCarouselInitialized && $(window).width() <= 1023) {
      $('#mobile-carousel-featured').owlCarousel({
      items: 1,
      nav: false,
      dots: false,
      loop: true,
      autoplay: false
      });
      isCarouselInitialized = true;
    }
  }

  initMobileCarousel();


  $(window).on('resize', function() {
    if ($(window).width() <= 1023) {
      if (!isCarouselInitialized) {
        initMobileCarousel();
      }
    } else {
  
      if (isCarouselInitialized) {
        $('#mobile-carousel-featured').trigger('destroy.owl.carousel');
        isCarouselInitialized = false;
      }
    }
  });
});